import React from "react";
import Chart from "./highcharts/Chart";
// import HighchartsReact from "highcharts-react-official";
import highcharts3d from "highcharts/highcharts-3d";
import Highcharts from "highcharts";
import { UseContextData } from "../../../context/dateContext";
highcharts3d(Highcharts);

const Donut3DChartHC = ({ data }) => {
  const { isDarkTheme, setIsDarkTheme } = UseContextData();

  // Calcular el total de la suma de los valores (segundo elemento de cada par)
  const total = data.reduce((acc, point) => acc + point[1], 0);

  const chartOptions = {
    chart: {
      type: "pie",
      height: "140px",
      backgroundColor: isDarkTheme ? "#444444" : "#ffffff",
      options3d: {
        enabled: true,
        alpha: 45,
      },
    },

    title: {
      text: null,
      align: "left",
    },
    subtitle: {
      text: null,
      align: "left",
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        innerSize: 50,
        depth: 45,
        dataLabels: {
          enabled: true,
          formatter: function () {
            const percentage = ((this.y / total) * 100).toFixed(2);
            return `${percentage}%`; // Mostrar solo el porcentaje
          },
          distance: -10, // Mover las etiquetas más cerca del donut
        },
      },
    },
    tooltip: {
      formatter: function () {
        const percentage = ((this.y / total) * 100).toFixed(2);
        return `<b>${this.point.name}</b><br/>Amount: ${this.y}<br/>Percentage: ${percentage}%`;
      },
    },
    series: [
      {
        name: "Amount of alerts",
        data: data.map(([name, value]) => ({ name, y: value })), // Convertir la data al formato esperado por Highcharts
      },
    ],
  };

  return <Chart options={chartOptions} highcharts={Highcharts} />;
};

export default Donut3DChartHC;
